import moment from 'moment';

const validate = (values, props) => {
  const errors = {};

  const accommodationIndex = props.initialValues.index;
  const accommodation = values.activities[accommodationIndex];

  if (!accommodation) return errors;

  if (
    !accommodation.dates ||
    !accommodation.dates.startDate ||
    !accommodation.dates.endDate
  ) {
    errors.dates = 'Dates are required';
  } else if (
    moment(accommodation.dates.endDate).diff(
      accommodation.dates.startDate,
      'days'
    ) < accommodation.minNights
  ) {
    errors.dates = {
      text: 'The number of nights cannot be less than',
      variables: { number: accommodation.minNights }
    };
  }

  if (accommodation.participants && accommodation.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    accommodation.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    accommodation.participants &&
    accommodation.participants.length
  ) {
    const availableParticipants = accommodation.startTime
      ? accommodation.startTime.seatsLeft
      : accommodation.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    accommodation.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
    }
  }

  if (!!Object.keys(errors).length) {
    const errorsCopy = { ...errors };
    errors.activities = {
      [accommodationIndex]: errorsCopy
    };
  }

  return errors;
};

export default validate;
